import { graphql } from '../gql';

export const getEffectiveConsentPreference = graphql(`
  query GetEffectiveConsentPreference {
    effectiveConsentPreference {
      error {
        code
        message
      }
      preference {
        consentGivenAt
        preferences {
          purpose
          value
        }
      }
    }
  }
`);
